import axios from "axios";

export const PublicLiveShowsInStudio = async (data: any, headers: any) => {
  const res = await axios.post("/api/get-live-shows-in-studio", data, headers);
  return res.data;
};
